import { render, staticRenderFns } from "./chart-shell.vue?vue&type=template&id=2bf437bf&scoped=true"
import script from "./chart-shell.vue?vue&type=script&lang=js"
export * from "./chart-shell.vue?vue&type=script&lang=js"
import style0 from "./chart-shell.vue?vue&type=style&index=0&id=2bf437bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf437bf",
  null
  
)

export default component.exports